import React, { Component } from 'react';
import FaqItem from './FaqItem';
import './PhaseOut.css';

class FaqContent extends Component {
  render() {
    return (
      <div className="item-wrapper">
        <FaqItem title="Apa itu GoFresh?">
          <p>
            GoFresh merupakan sebuah layanan dari GoJek berupa marketplace yang
            menghubungkan partner GoFood dengan dengan supplier bahan makanan
            berkualitas.
          </p>
        </FaqItem>
        <FaqItem title="Apakah saya harus melakukan pendaftaran ulang untuk GoFresh?">
          <p>
            Saat ini GoFresh hanya bisa diakses melalui aplikasi GoBiz yang
            hanya tersedia untuk smartphone Android. Akun GoBiz{' '}
            <b>wajib diperlukan</b> untuk melakukan order di platform GoFresh.
            Mengingat GoFresh masih dalam tahap belum dibuka untuk umum maka
            akan ada proses pendaftaran untuk dapat berbelanja di GoFresh.
          </p>
          <p>
            Jika anda belum memiliki GoBiz maka anda harus mendaftar terlebih
            dahulu. Langkah-langkah pendaftaran akun dapat dilihat dengan cara
            menekan link <b>“Cara mendaftar GoBiz”</b> di bawah. Kemudian klik
            pada judul <b>“Bagaimana cara mendaftar GoBiz?”</b>
          </p>
          <a
            target="_blank"
            href="https://www.gojek.com/gofood/partner-center/faq/gobiz/#how-do-i-sign-up-for-gobiz"
          >
            Cara mendaftar GoBiz
          </a>
          <p>
            Jika anda sudah memiliki akun GoBiz namun belum memliki akses
            GoFresh sebelumnya maka anda dapat menekan tombol <b>“Daftar”</b> di
            halaman Moka Fresh di backoffice untuk dapat kami berikan akses
            berbelanja di GoFresh. Tombol <b>“Daftar”</b> hanya dapat dilihat di
            backoffice versi <b>mobile.</b>
          </p>
          <p>
            Jika anda sudah memiliki akses ke GoFresh maka anda dapat menekan
            tombol <b>“Mulai Belanja”</b>. Tombol <b>“Mulai Belanja”</b> hanya
            dapat dilihat di backoffice <b>versi mobile</b>. Jika anda belum
            memiliki aplikasi GoBiz di smartphone anda maka anda akan diarahkan
            ke halaman download aplikasi GoBiz.
          </p>
        </FaqItem>
        <FaqItem title="Metode pembayaran apa saja yang tersedia di GoFresh?">
          <p>
            Berikut ini merupakan metode pembayaran yang tersedia di GoFresh:
          </p>
          <ul>
            <li>a. Virtual Account BCA</li>
            <li>b. Virtual Account non-BCA</li>
            <li>c. Alfamart</li>
            <li>d. GoPay</li>
            <li>e. Saldo GoBiz</li>
            <li>f. Kartu Kredit</li>
          </ul>
          <p>
            Berikut ini merupakan biaya admin untuk masing-masing biaya
            pembayaran:
          </p>
          <ul>
            <li>a. BCA Rp 2.500,-</li>
            <li>b. Bank lain Rp 3.300,-</li>
            <li>c. Alfamart Rp 5.000,-</li>
            <li>d. Kartu Kredit 5% dari total transaksi</li>
          </ul>
        </FaqItem>
        <FaqItem title="Bagaimana Cara membuat pesanan di GoFresh?">
          <p>
            Untuk melihat cara membuat pesanan di GoFresh kamu dapat langsung
            menekan link di bawah ini.
          </p>
          <a
            target="_blank"
            href="https://bantuan.gobiz.co.id/s/article/Bagaimana-cara-membuat-pemesanan-di-GoFresh"
          >
            Cara melakukan pesanan di GoFresh
          </a>
        </FaqItem>
        <FaqItem title="Saya masih punya pertanyaan seputar GoFresh">
          <p>
            Untuk pertanyaan - pertanyaan lainnya seputar GoFresh anda dapat
            langsung menuju pusat bantuan GoFresh dengan menekan link di bawah
            ini
          </p>
          <a
            target="_blank"
            href="https://bantuan.gobiz.co.id/s/topic/0TO0I000000MyU5WAK/panduan-fitur-gofresh"
          >
            Panduan GoFresh
          </a>
        </FaqItem>
      </div>
    );
  }
}

export default FaqContent;
